module.exports = __webpack_public_path__ + "img/bblz.805355f3.png";